import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getDashboardApi } from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";

const Dashboard = () => {
  const notification = useToastContext();
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");

  const [loader, setLoader] = useState(false)
  const [dashboardDetail, setDashboardDetail] = useState({})

  const getDashboardCount = () => {
    getDashboardApi({}, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setDashboardDetail(response);
      }
    });
  }

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      }
    } else {
      navigate("/");
    }
  }, [Token]);

  useEffect(() => {
    getDashboardCount()
  }, [])

  return (
    <div className="right-panel">
      <section className="no-of-sections p-xl-4 p-3">
        {loader ? (
          <Container className="d-flex justify-content-center align-items-center default-back">
            <span>
              <LottiLoader height={120} width={120} loader={true} />
            </span>
          </Container>
        ) : (<Row className="gx-3">
          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.activeUserCount || "-"}</h3>
              <div className="content-info">Number of Active Members</div>
            </Card>
          </Col>

          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.paymentCount || "-"}</h3>
              <div className="content-info">Number of Payment Members</div>
            </Card>
          </Col>

          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.teamCount || "-"}</h3>
              <div className="content-info">Number of Team Members</div>
            </Card>
          </Col>

          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.eventCount || "-"}</h3>
              <div className="content-info">Number of Events</div>
            </Card>
          </Col>
          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.matrimonialCount || "-"}</h3>
              <div className="content-info">Number of Matrimonial Records</div>
            </Card>
          </Col>
          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.employmentCount || "-"}</h3>
              <div className="content-info">Number of Job Listings</div>
            </Card>
          </Col>
          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.suvicharCount || "-"}</h3>
              <div className="content-info">Number of Suvichars</div>
            </Card>
          </Col>

          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.contactUsCount || "-"}</h3>
              <div className="content-info">Number of Contact Us Submissions</div>
            </Card>
          </Col>

          <Col xl={4} sm={6} className="mb-3">
            <Card>
              <h3>{dashboardDetail?.suggestionCount || "-"}</h3>
              <div className="content-info">Number of Suggestions</div>
            </Card>
          </Col>
        </Row>)}

      </section>
    </div>
  );
};

export default Dashboard;

// No of Members,no of volumnteers,no of Active user
